export const ICON_FONT_SET_CLASSES: readonly string[] = [
  'material-icons-round',
  'mat-ligature-font',
];

export const ICON_SIZE = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
} as const;

export type IconSize = (typeof ICON_SIZE)[keyof typeof ICON_SIZE];

export const ICON_SIZE_CLASS: Record<IconSize, string> = {
  [ICON_SIZE.XS]: 'icon-xs',
  [ICON_SIZE.SM]: 'icon-sm',
  [ICON_SIZE.MD]: 'icon-md',
  [ICON_SIZE.LG]: 'icon-lg',
  [ICON_SIZE.XL]: 'icon-xl',
};
